export default {
  index: {
    index: {
      pad: 'aw330',
      aads: {
        'id-1': 'aw330_1', // 讲次列表-备课
        'id-2': 'aw330_2', // 讲次列表-去上课/视频上课/课件上课
        'id-3': 'aw330_3', // 即将上课提醒-讲次下拉表
        'id-4': 'aw330_4', // 即将上课提醒-去上课/视频上课/课件上课
        'id-5': 'aw330_5', // 即将上课提醒-关闭
        'id-6': 'aw330_6', // 选择讲次对话框中“课程资料”按钮
        'id-7': 'aw330_7', // 选择讲次对话框中“学情分析”按钮
        'id-8': 'aw330_8', // 讲次列表-快速建班按钮
        'id-9': 'aw330_9', // 选择讲次对话框中“添加学员”按钮
        'id-10': 'aw330_10', // 选择讲次对话框中“错题本”按钮
        'id-11': 'aw330_11', // 全部课程-高级筛选
        'id-12': 'aw330_12', // 选择讲次对话框停留时间
        'id-13': 'aw330_13', // [去上课]跳转到快速建立班级
        'id-14': 'aw330_14', // [去上课]跳转到非快速建立班级
        'id-15': 'aw330_15', // 全部课程无班型时提示部分-刷新
        'id-16': 'aw330_16', // 全部课程无班型时提示部分-前去设置
        'id-17': 'aw330_17', // 搜索课程
      },
    },
    lessondata: {
      aads: {
        'id-1': 'aw_ld_1', // 批量打印学生错题
        'id-2': 'aw_ld_2', // 打印错题（单个）
      },
    },
    history: {
      pad: 'aw331',
      aads: {
        'id-1': 'aw331_1', // 查看更多课程
        'id-2': 'aw331_2', // 删除
        'id-3': 'aw331_3', // 上次备课-继续备课
        'id-4': 'aw331_4', // 点击创建班级
        'id-5': 'aw331_5', // 点击快速授课
        'id-7': 'aw331_7', // 课堂标签-悬浮弹窗【查看详情】按钮
        'id-8': 'aw331_8', // 预上线-弹窗【了解详情】按钮
        'id-9': 'aw331_9', // 超级课件悬浮窗
        'id-10': 'aw331_10', // 账号到期去续费
        'id-11': 'aw331_11', // 我的班级
        'id-12': 'aw331_12', // 全部课程
        'id-13': 'aw331_13', // 我的班级-高级筛选
        'id-14': 'aw331_14', // 新手引导-继续
        'id-15': 'aw331_15', // 新手引导-完成
        'id-16': 'aw331_16', // 新手引导-跳过
        'id-17': 'aw331_17', // 去建班
        'id-18': 'aw331_18', // 精准学TAB
        'id-19': 'aw331_19', // 班级卡片
      },
    },
  },
  home: {
    index: {
      pad: 'aw330',
      aads: {
        'id-1': 'aw330_1', // 讲次列表-备课
        'id-2': 'aw330_2', // 讲次列表-去上课/视频上课/课件上课
        'id-3': 'aw330_3', // 即将上课提醒-讲次下拉表
        'id-4': 'aw330_4', // 即将上课提醒-去上课/视频上课/课件上课
        'id-5': 'aw330_5', // 即将上课提醒-关闭
        'id-6': 'aw330_6', // 选择讲次对话框中“课程资料”按钮
        'id-7': 'aw330_7', // 选择讲次对话框中“学情分析”按钮
        'id-8': 'aw330_8', // 讲次列表-快速建班按钮
        'id-9': 'aw330_9', // 选择讲次对话框中“添加学员”按钮
        'id-10': 'aw330_10', // 选择讲次对话框中“错题本”按钮
        'id-11': 'aw330_11', // 全部课程-高级筛选
        'id-12': 'aw330_12', // 选择讲次对话框停留时间
        'id-13': 'aw330_13', // [去上课]跳转到快速建立班级
        'id-14': 'aw330_14', // [去上课]跳转到非快速建立班级
        'id-15': 'aw330_15', // 全部课程无班型时提示部分-刷新
        'id-16': 'aw330_16', // 全部课程无班型时提示部分-前去设置
        'id-17': 'aw330_17', // 搜索课程
      },
    },
    history: {
      pad: 'aw331',
      aads: {
        'id-1': 'aw331_1', // 查看更多课程
        'id-2': 'aw331_2', // 删除
        'id-3': 'aw331_3', // 上次备课-继续备课
        'id-4': 'aw331_4', // 点击创建班级
        'id-5': 'aw331_5', // 点击快速授课
        'id-7': 'aw331_7', // 课堂标签-悬浮弹窗【查看详情】按钮
        'id-8': 'aw331_8', // 预上线-弹窗【了解详情】按钮
        'id-9': 'aw331_9', // 超级课件悬浮窗
        'id-10': 'aw331_10', // 账号到期去续费
        'id-11': 'aw331_11', // 我的班级
        'id-12': 'aw331_12', // 全部课程
        'id-13': 'aw331_13', // 我的班级-高级筛选
        'id-14': 'aw331_14', // 新手引导-继续
        'id-15': 'aw331_15', // 新手引导-完成
        'id-16': 'aw331_16', // 新手引导-跳过
        'id-17': 'aw331_17', // 去建班
      },
    },
  },
  courseInfo: {
    kejian: {
      pad: 'aw332',
      aads: {
        'id-1': 'aw332_1', // 讲次切换
        'id-2': 'aw332_2', // 去上课
        'id-3': 'aw332_3', // 视频上课
        'id-4': 'aw332_4', // 课件上课
        'id-5': 'aw332_5', // 视频模式
        'id-6': 'aw332_6', // 课件模式
        'id-7': 'aw332_7', // 个人备注
        'id-8': 'aw332_8', // 收起/展开批注
        'id-9': 'aw332_9', // 辅助工具栏-课程资料
        'id-10': 'aw332_10', // 辅助工具栏-备课帮助
        'id-11': 'aw332_11', // 课件模式-课件目录(todo: 暂不支持)
        'id-12': 'aw332_12', // 课件模式-课件卡顿
        'id-13': 'aw332_13', // 课件模式-课件全屏
        'id-14': 'aw332_14', // 课件模式-缩略图
        'id-15': 'aw332_15', // 课件模式-视频播放
        'id-16': 'aw332_16', // 课件模式-视频全屏
        'id-17': 'aw332_17', // 课件模式-视频目录切换
        'id-18': 'aw332_18', // 课件模式-新版目录
        'id-19': 'aw332_19', // 课件模式-开火车开启
        'id-20': 'aw332_20', // 课件模式-开火车跳过
        'id-21': 'aw332_21', // 课件模式-开火车结束答题
        'id-22': 'aw332_22', // 课件模式-随机提问
        'id-23': 'aw332_23', // 视频模式-视频全屏
        'id-24': 'aw332_24', // 视频模式-新版目录
        'id-25': 'aw332_25', // 视频模式-右侧课件换页
        'id-26': 'aw332_26', // 视频模式-开火车跳过
        'id-27': 'aw332_27', // 视频模式-开火车开启
        'id-28': 'aw332_28', // 视频模式-开火车结束答题
        'id-29': 'aw332_29', // 问题反馈
        'id-30': 'aw332_30', // 辅助工具栏-学情分析
        'id-31': 'aw332_31', // 辅助工具栏-班级进入-错题本
        'id-32': 'aw332_32', // 辅助工具栏--班型进入-错题本
        'id-33': 'aw332_33', // 辅助工具栏-专题课-班级进入点击次数
        'id-34': 'aw332_34', // 辅助工具栏-专题课-班型进入点击次数
        'id-35': 'aw332_35', // 辅助工具栏-查看英语课前预习-班级进入点击次数
        'id-36': 'aw332_36', // 辅助工具栏-查看英语课前预习-班型进入点击次数'id-36': 'aw332_36'
        'id-37': 'aw332_37', // 备课界面说课视频收起、展开按钮点击次数
        'id-38': 'aw332_38', // 习题选项展开收起按钮点击次数
        'id-39': 'aw332_39', // 左上角“返回”按钮
        'id-42': 'aw332_42', // 备课超级视频按钮（知识点）
        'id-43': 'aw332_43', // 备课超级视频按钮（题解）
      },
    },
    jiaoan: {
      pad: 'aw333',
      aads: {
        'id-1': 'aw333_1', // 打印讲义
        'id-5': 'aw333_5', // 例题练习题
        'id-6': 'aw333_6', // 课堂落实答案(进门考)
        'id-7': 'aw333_7', // 自我巩固答案
        'id-8': 'aw333_8', // 期中试卷
        'id-9': 'aw333_9', // 期末试卷
        'id-11': 'aw333_11', // 批注教案
        'id-12': 'aw333_12', // 习题答案
        'id-14': 'aw333_14', // 带做例题
        'id-15': 'aw333_15', // 英语学科包含 PDF 和结构化数据时显示的“课件讲义”选项的点击次数
      },
    },
    ketangshilu: {
      pad: 'aw334',
      aads: {
        'id-1': 'aw334_1', // 点击课堂实录视频
      },
    },
    gexinghuajiaoan: {
      pad: 'aw335',
      aads: {
        'id-1': 'aw335_1', // 标记重难点
        'id-2': 'aw335_2', // 标记不讲
        'id-3': 'aw335_3', // 记录时间
        'id-4': 'aw335_4', // 预览并打印
      },
    },
    xueyuangonggu: {
      pad: 'aw336', // 学员巩固
    },
    zhuanshuti: {
      pad: 'aw337', // 专属题
    },
    kaoquzhenti: {
      pad: 'aw338', // 考区真题
    },
    waijiaokejian: {
      pad: 'aw339', // 外教课件
    },
    viewPrint: {
      pad: 'aw340', // 打印预览
    },
    print: {
      pad: 'aw341', // 非diy打印
    },
    printdiy: {
      pad: 'aw342', // diy打印
    },
    caseScratch: {
      pad: 'aw371', // 提示案例 scratch
      aads: {
        'id-1': 'aw371_1', // 案例点击
        'id-2': 'aw371_2', // 头部去上课按钮
      },
    },
    casePython: {
      pad: 'aw372', // 提示案例 python
      aads: {
        'id-1': 'aw372_1', // 头部去上课按钮
      },
    },
    aiVideo: {
      pad: 'aw375',
    },
  },
  shouke: {
    index: {
      pad: 'aw349',
      aads: {
        'id-1': 'aw349_1', // 工具条
        'id-2': 'aw349_2', // 工具条-点名
        'id-3': 'aw349_3', // 工具条-目录
        'id-4': 'aw349_4', // 工具条-上讲巩固
        'id-5': 'aw349_5', // 工具条-随机提问
        'id-6': 'aw349_6', // 工具条-上将课件
        'id-7': 'aw349_7', // 工具条-倒计时
        'id-8': 'aw349_8', // 工具条-考区真题
        'id-9': 'aw349_9', // 工具条-精选精炼
        'id-10': 'aw349_10', // 工具条-加积分
        'id-11': 'aw349_11', // 工具条-积分榜
        'id-12': 'aw349_12', // 工具条-增删学员
        'id-13': 'aw349_13', // 工具条-班级榜单
        'id-14': 'aw349_14', // 工具条-随机开麦
        'id-15': 'aw349_15', // 翻页键
        'id-16': 'aw349_16', // 随机提问-点击屏幕暂停
        'id-17': 'aw349_17', // 随机提问-暂时未到
        'id-18': 'aw349_18', // 随即问题-再换一人
        'id-19': 'aw349_19', // 开火车-跳过
        'id-20': 'aw349_20', // 开火车-开始
        'id-21': 'aw349_21', // 开火车-换人
        'id-22': 'aw349_22', // 开火车-倒计时（耗尽一次）
        'id-23': 'aw349_23', // 开火车-榜单
        'id-24': 'aw349_24', // 开会车-榜单-题目详情-上下翻页按钮
        'id-25': 'aw349_25', // 下发弹窗-取消按钮
        'id-26': 'aw349_26', // 下发弹窗-确定按钮
        'id-27': 'aw349_27', // 工具条-课堂落实
        'id-28': 'aw349_28', // 工具条-缩略图
        'id-29': 'aw349_29', // 工具条-习题提问
        'id-30': 'aw349_30', // 工具条-随口提问-1金币点击
        'id-31': 'aw349_31', // 工具条-随口提问-2金币点击
        'id-32': 'aw349_32', // 工具条-随口提问-3金币点击
        'id-33': 'aw349_33', // 工具条-随口提问-4金币点击
        'id-34': 'aw349_34', // 工具条-随口提问-5金币点击
        'id-35': 'aw349_35', // 工具条-随口提问-老师手动点击“公布答案”按钮
        'id-36': 'aw349_36', // 工具条-随口提问-老师选择A
        'id-37': 'aw349_37', // 工具条-随口提问-老师选择B
        'id-38': 'aw349_38', // 工具条-随口提问-老师选择C
        'id-39': 'aw349_39', // 工具条-随口提问-老师选择D
        'id-40': 'aw349_40', // 工具条-随口提问-优秀榜单点击
        'id-41': 'aw349_41', // 工具条-随口提问-答题情况点击
        'id-42': 'aw349_42', // 工具条-随口提问
        'id-43': 'aw349_43', // 工具条-随口提问-规定时间用完跳到公布答案界面
        'id-44': 'aw349_44', // 工具条-随口提问-学生全部作答完但时间没用完
        'id-45': 'aw349_45', // 工具条-习题提问-加30s点击次数
        'id-46': 'aw349_46', // 工具条-习题提问-减30s点击次数
        'id-47': 'aw349_47', // 工具条-习题提问-返回点击次数
        'id-48': 'aw349_48', // 工具条-白板
        'id-49': 'aw349_49', // 工具条-白板-上一步
        'id-50': 'aw349_50', // 工具条-白板-下一步
        'id-51': 'aw349_51', // 工具条-白板-清空
        'id-52': 'aw349_52', // 工具条-白板-保存
        'id-53': 'aw349_53', // 工具条-白板-画板
        'id-54': 'aw349_54', // 工具条-白板-橡皮
        'id-55': 'aw349_55', // 工具条-白板-笔刷
        'id-56': 'aw349_56', // 工具条-白板-收起
        'id-57': 'aw349_57', // 工具条-面授答题器-红包
        'id-58': 'aw349_58', // 工具条-学生签到
        'id-59': 'aw349_59', // 工具条-面授答题器-习题提问
        'id-60': 'aw349_60', // 工具条-面授答题器-分组pk
        'id-150': 'aw349_150', // 工具条-下课
        'id-151': 'aw349_151', // 工具条-课堂调研
        'id-152': 'aw349_152', // 工具条-红包
        'id-153': 'aw349_153', // 工具条二级按钮-普通红包
        'id-154': 'aw349_154', // 工具条二级按钮-节日红包
        'id-61': 'aw349_61', // 课件-习题提问
        'id-62': 'aw349_62', // 随机问题-一星
        'id-63': 'aw349_63', // 随机问题-二星
        'id-64': 'aw349_64', // 随机问题-三星

        'id-65': 'aw349_65', // 倒计时-编辑-点击开始（参数时间{sec: number}）
        'id-66': 'aw349_66', // 倒计时-编辑-点击全屏
        'id-67': 'aw349_67', // 倒计时-编辑-点击重置
        'id-68': 'aw349_68', // 倒计时-编辑-点击关闭
        'id-69': 'aw349_69', // 倒计时-极简-点击暂停/继续
        'id-70': 'aw349_70', // 倒计时-极简-点击结束
        'id-71': 'aw349_71', // 倒计时-极简-点击设置
        'id-72': 'aw349_72', // 倒计时-极简-点击全屏
        'id-73': 'aw349_73', // 倒计时-全屏-点击暂停/继续
        'id-74': 'aw349_74', // 倒计时-全屏-点击结束
        'id-75': 'aw349_75', // 倒计时-全屏-点击设置
        'id-76': 'aw349_76', // 倒计时-全屏-点击取消全屏
        'id-77': 'aw349_77', // 倒计时-编辑-点击按钮时间（参数时间类型： {type:0//2分钟,type:1//5分钟,type:2//15分钟,type:3//1小时}
        'id-78': 'aw349_78', // 金币榜点击次数
        'id-79': 'aw349_79', // 查看历史标签按钮
        'id-80': 'aw349_80', // 学生列表关闭按钮
        'id-81': 'aw349_81', // 选择标签返回按钮
        'id-82': 'aw349_82', // 选择标签表扬点击
        'id-83': 'aw349_83', // 选择标签批评点击
        'id-84': 'aw349_84', // 历史返回
        'id-85': 'aw349_85', // 历史关闭
        'id-86': 'aw349_86', // 课堂标签点击次数
        'id-87': 'aw349_87', // 授课超级视频按钮（知识点）
        'id-88': 'aw349_88', // 授课超级视频按钮（题解）
      },
    },
    homework: {
      pad: 'aw343',
      aads: {
        'id-1': 'aw343_1', // 目录
        'id-2': 'aw343_2', // 翻页
        'id-3': 'aw343_3', // 答案
        'id-4': 'aw343_4', // 点击屏幕翻页
        'id-5': 'aw343_5', // 去授课
        'id-6': 'aw343_6', // 上讲巩固榜单
      },
    },
    jxjl: {
      pad: 'aw344', // 精选精练
    },
    kaoqu: {
      pad: 'aw345',
      aads: {
        'id-1': 'aw345_1', // 切换考区
      },
    },
    call: {
      pad: 'aw346', // 点名
      aads: {
        'id-1': 'aw346_1', // 提交点名成功
        'id-2': 'aw346_2', // 【上讲巩固】按钮点击次数
        'id-3': 'aw346_3', // 点名音效开关按钮
        'id-4': 'aw346_4', // 补签按钮的点击次数
        'id-5': 'aw346_5', // 取消补签按钮的点击次数
      },
    },
    'add-student': {
      pad: 'aw347', // 添加学员
      aads: {
        'id-1': 'aw347_1', // 添加学员
        'id-2': 'aw347_2', // 移除学员
      },
    },
    redbag: {
      pad: 'aw366',
      aads: {
        'id-1': 'aw366_1',
        'id-2': 'aw366_2',
      },
    },
    homeworklist: {
      pad: 'aw356', // 自我巩固榜单页面
      aads: {
        'id-1': 'aw356_1', // 点名按钮
        'id-2': 'aw356_2', // 去授课按钮
        'id-3': 'aw356_3', // 上讲巩固按钮
        'id-4': 'aw356_4', // 荣誉榜按钮
        'id-5': 'aw356_5', // 努力榜按钮
      },
    },
    xttw: {
      pad: 'aw367', // 习题提问
    },
    'honour-rank': {
      pad: 'aw368', // 荣耀帮
    },
    signIn: {
      pad: 'aw369', // 签到页
    },
  },
  teachplan: {
    index: {
      pad: 'aw348',
      aads: {
        'id-1': 'aw348_1', // 教学计划-下载
        'id-2': 'aw348_2', // 教师讲义-打印
        'id-3': 'aw348_3', // 教学计划
        'id-4': 'aw348_4', // 教师讲义
        'id-5': 'aw348_5', // 课程资料下载
      },
    },
  },
  studentAnalysis: {
    index: {
      pad: 'aw351', // 学情分析
    },
  },
  wrongBook: {
    index: {
      pad: 'aw352', // 错题本
    },
    wrongBookInfo: {
      pad: 'aw353', // 错题本详情
      aads: {
        'id-1': 'aw353_1', // 错题本列表-下载
      },
    },
  },
  specialPreviewCourses: {
    special: {
      pad: 'aw354', // 专题课
    },
    preview: {
      pad: 'aw355', // 查看英语课前预习
    },
  },
  createClass: {
    index: {
      pad: 'aw357', // 快速建班页面
      aads: {
        'id-1': 'aw357_1', // 创建班级
        'id-2': 'aw357_2', // 返回
      },
    },
    success: {
      pad: 'aw358', // 快速建班成功页面
      aads: {
        'id-1': 'aw358_1', // 返回备授课
        'id-2': 'aw358_2', // 去上课
        'id-3': 'aw358_3', // 专题
        'id-4': 'aw358_4', // 备课
        'id-5': 'aw358_5', // 添加学员
      },
    },
  },
  client: {
    login: {
      pad: 'aw360', // 客户端登录
      aads: {
        'id-1': 'aw360_1', // 忘记密码按钮
      },
    },
    index: {
      pad: 'aw361', // 客户端班级列表页
      aads: {
        'id-1': 'aw361_1', // 第一次进入对话框“取消”的点击事件
        'id-2': 'aw361_2', // 第一次进入对话框“绑定”的点击事件
        'id-3': 'aw361_3', // 签到名单的点击事件
        'id-4': 'aw361_4', // 绑定答题器
      },
    },
    'check-device': {
      pad: 'aw362', // 客户端-设备检测页
      aads: {
        'id-1': 'aw362_1', // 设备自检中，“重新检测”点击事件
        'id-2': 'aw362_2', // 设备自检中，“跳过”点击事件
        'id-3': 'aw362_3', // 答题器检测提示语中“重新检测”点击事件
        'id-4': 'aw362_4', // 答题器检测提示语中“取消”点击事件
        'id-5': 'aw362_5', // 扬声器检测提示语“是”点击事件
        'id-6': 'aw362_6', // 扬声器检测提示语“否”点击事件
        'id-7': 'aw362_7', // 自检未成功提示语“跳过”点击事件
        'id-8': 'aw362_8', // 自检未成功提示语“取消”点击事件
        'id-9': 'aw362_9', // 界面左上角的叉号点击事件
      },
    },
    'answer-machine': {
      pad: 'aw363', // 客户端-答题器绑定
      aads: {
        'id-1': 'aw363_1', // “清空列表”绑定事件
        'id-2': 'aw363_2', // “结束绑定”绑定事件
        'id-3': 'aw363_3', // 界面左上角的叉号点击事件
      },
    },
    'match-machine': {
      pad: 'aw364', // 客户端-学员签到
      aads: {
        'id-1': 'aw364_1', // “绑定答题器”的点击事件
        'id-2': 'aw364_2', // 开始上课
        'id-3': 'aw364_3', // 退签
      },
    },
    'start-class': {
      pad: 'aw365', // 客户端-开始上课页
      aads: {
        'id-1': 'aw365_1', // “学生签到”点击事件
        'id-2': 'aw365_2', // “开始上课”点击事件
      },
    },
  },
  kingOfMind: {
    index: {
      pad: 'aw370',
      aads: {
        'id-1': 'aw370_1', // 授课：【头脑王者】点击次数
        'id-2': 'aw370_2', // 授课：【开始】按钮点击次数
        'id-3': 'aw370_3', // 授课：【跳过】按钮点击次数
        'id-4': 'aw370_4', // 授课：【关闭】按钮点击次数
        'id-5': 'aw370_5', // 授课：【学生榜单】按钮点击次数
        'id-6': 'aw370_6', // 授课：【题目详情】按钮点击次数
        'id-7': 'aw370_7', // 备课：【跳过】按钮点击次数
        'id-8': 'aw370_8', // 备课：【查看题目】按钮点击次数
        'id-9': 'aw370_9', // 备课：【查看演示视频】按钮点击次数
      },
    },
  },
  download: {
    index: {
      pad: 'aw376',
      aads: {
        'id-1': 'aw376_1',
      },
    },
  },
  addStudent: {
    index: {
      pad: 'aw379',
      aads: {
        'id-1': 'aw379_1', // 【添加学员】按钮的点击次数
        'id-2': 'aw379_2', // 【返回】按钮的点击次数
        'id-3': 'aw379_3', // 添加学员弹窗-【搜索】按钮的点击次数
        'id-4': 'aw379_4', // 添加学员弹窗-【添加学员】按钮的点击次数
        'id-5': 'aw379_5', // 添加学员弹窗-【+】按钮的点击次数
        'id-6': 'aw379_6', // 添加学员弹窗-【返回】按钮的点击次数
        'id-7': 'aw379_7', // 已选择学员-【删除】按钮的点击次数
        'id-8': 'aw379_8', // 添加学员弹窗-【确认】按钮的点击次数
        'id-9': 'aw379_9', // 添加学员弹窗-【取消】按钮的点击次数
        'id-10': 'aw379_10', // 添加学员弹窗-【关闭弹窗】按钮的点击次数
      },
    },
  },
  shilu: {
    index: {
      pad: 'aw381',
    },
  },
  fromPad: {
    index: {
      pad: 'aw389',
      aads: {
        'id-1': 'aw389_1', // 爱学习课件tab
        'id-2': 'aw389_2', // 公立校教材课件tab
        'id-3': 'aw389_3', // 老师教
        'id-4': 'aw389_4', // AI课
        'id-5': 'aw389_5', // 自由练
        'id-6': 'aw389_6', // 创建讲次btn
        'id-7': 'aw389_7', // 修改讲次btn
        'id-8': 'aw389_8', // 调序
        'id-9': 'aw389_9', // 切换
        'id-10': 'aw389_10', // 查看btn
        'id-11': 'aw389_11', // 备课btn
        'id-12': 'aw389_12', // 删除btn
        'id-13': 'aw389_13', // 创建讲次btn
      },
    },
  },
};
